import { render, staticRenderFns } from "./project-documents-upload.vue?vue&type=template&id=4265aca2&scoped=true&"
import script from "./project-documents-upload.vue?vue&type=script&lang=js&"
export * from "./project-documents-upload.vue?vue&type=script&lang=js&"
import style0 from "./project-documents-upload.vue?vue&type=style&index=0&id=4265aca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4265aca2",
  null
  
)

export default component.exports